import React from 'react';
import { CandidateInfoViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: CandidateInfoViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
